/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { Certification, FaqSection } from '../shared/models';
import { AcademyCertificationsService } from '../services/academy-certifications.service';
import { CertificationCardComponent } from './certification-card/certification-card.component';
import { AcademyFaqComponent } from '../shared/components/academy-faq/academy-faq.component';
import { CERTIFICATION_FAQ_SECTIONS } from './certification-faqs.constants';

@Component({
  selector: 'ut-academy-certifications',
  templateUrl: './academy-certifications.component.html',
  styleUrls: ['./academy-certifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, CertificationCardComponent, AcademyFaqComponent],
})
export class AcademyCertificationsComponent {
  certifications$: Observable<Certification[]> = this.certificationsService.getCertifications();
  faqSections: FaqSection[] = CERTIFICATION_FAQ_SECTIONS;

  constructor(private certificationsService: AcademyCertificationsService) {}
}
